export const centsToDollars = (
	cents: number,
	withCents = true,
	withPriceIndicator = true
): string => {
	if (cents === 0) return `${withPriceIndicator ? '$' : ''}0`;
	const centStr = '' + cents;
	return `${withPriceIndicator ? '$' : ''}${centStr.slice(0, -2)}${
		withCents ? `.${centStr.slice(-2)}` : ''
	}`;
};
